import CreateEventForm from "../forms/CreateEventForm.jsx";
import Modal from "../modals/Modal.jsx";
import Button from "../ui/Button.jsx";

function AddEventModal(){
    
    return <Modal>
        <Modal.Open opens="event-form">
            <Button>Add Event</Button>
        </Modal.Open>
        <Modal.Window name="event-form">
            <CreateEventForm/>
        </Modal.Window>
    </Modal>
}

export default AddEventModal;